import dayjs from 'dayjs';

/** Local calendar date for route stop plannedAt (same approach as RouteStructureBlock). */
export function formatRouteStopPlannedAt(value: string | null | undefined): string | null {
  if (!value) return null;
  const parsed = dayjs(value);
  if (!parsed.isValid()) return null;
  return parsed.format('DD.MM.YYYY');
}
